export const FETCH_ASSETS = "FETCH_ASSETS";
export const FETCH_ASSETS_SUCCESS = "FETCH_ASSETS_SUCCESS";
export const FETCH_ASSETS_FAILURE = "FETCH_ASSETS_FAILURE";
export const RESET_FETCH_ASSETS = "RESET_FETCH_ASSETS";



